export const { isArray } = Array
